<script setup lang="ts">
import { TabsTrigger, useForwardPropsEmits } from 'radix-vue'
import type { TabsTriggerProps } from 'radix-vue'

const props = defineProps<TabsTriggerProps>()

const forwarded = useForwardPropsEmits(props)
</script>

<template>
  <TabsTrigger v-bind="forwarded" :class="$style.trigger">
    <slot />
  </TabsTrigger>
</template>

<style lang="scss" module>
.trigger {
  color: $color-text-and-object-low-emphasis;
  font-weight: 700;
  padding: 12px 16px;
  border-bottom: 3px solid transparent;

  &[data-state='active'] {
    color: $color-border-accent-primary;
    border-color: $color-border-accent-primary;
  }

  &[data-disabled] {
    color: $color-text-and-object-disable;
    cursor: not-allowed;
  }
}
</style>
